import { format } from "date-fns";

import { ConfirmModal, FormText, FormCheckbox } from "@components/index";
import { SubmissionModel } from "@interfaces/index";

export const SubmitConfirmModal = ({
  show,
  submissionDetails,
  isSubmittingBeforePeriodEnd,
  comment,
  disabledConfirmButton,
  onCommentChange,
  onToggleConfirmedAgree,
  onClickCancel,
  onClickConfirm,
}: {
  show: boolean;
  submissionDetails?: SubmissionModel;
  isSubmittingBeforePeriodEnd: boolean;
  comment: string;
  disabledConfirmButton: boolean;
  onCommentChange: (value: string) => void;
  onToggleConfirmedAgree: () => void;
  onClickCancel: () => void;
  onClickConfirm: () => void;
}) => (
  <ConfirmModal
    show={show}
    confirmButtonTitle="Submit"
    disabledConfirmButton={disabledConfirmButton}
    onClickCancel={onClickCancel}
    onClickConfirm={onClickConfirm}
  >
    <div className="text-center text-400 font-bold text-black-100 md:text-500">
      Submit This Data
    </div>
    {submissionDetails && isSubmittingBeforePeriodEnd && (
      <div className="mt-4 border-l-4 border-l-brown-100 bg-orange-8 px-4 py-2 text-left">
        You are about to submit data for the {submissionDetails.period.title}{" "}
        ending on{" "}
        {format(new Date(submissionDetails.period.endDate), "dd.MM.yyyy")}. Do
        you want to continue?
        <br />
        <br />
        <strong>Warning:</strong> Once you submit data for the{" "}
        {submissionDetails.period.title} ending on{" "}
        {format(new Date(submissionDetails.period.endDate), "dd.MM.yyyy")},
        changes may not be possible. Are you sure you want to continue?
      </div>
    )}
    <FormText
      name="comment"
      label=""
      placeholder="Note"
      className="mt-6"
      value={comment}
      onChange={({ currentTarget }) => onCommentChange(currentTarget.value)}
    />
    <FormCheckbox
      name="confirm"
      label="I confirm to the best of my knowledge that this data is complete and accurate."
      className="mt-6 text-left"
      onChange={onToggleConfirmedAgree}
    />
  </ConfirmModal>
);
